<div class="flex justify-center">
	<div class="flex flex-col">
		<div class="self-end flex">
			<ui-button
				[style]="'outline'"
				color="gray"
				label="Print Map"
				icon="printer"
				(click)="printMap()"
			></ui-button>
		</div>
		<div id="adjacent-lot-map" class="h-full w-full">
			<img [src]="imageSrc" />
		</div>
	</div>
</div>
